import React from 'react';
import { Camera, X } from 'lucide-react';
import { Language } from '../types';

interface FirstCaptureNudgeProps {
    language: Language;
    onShowCapture: () => void;
    onDismiss: () => void;
}

const copy = {
    vietnamese: {
        title: 'PDF đã sẵn sàng. Bây giờ hãy capture đoạn đầu tiên.',
        body: 'Đọc tài liệu ở panel bên phải. Khi gặp công thức, đoạn văn hoặc ý tưởng quan trọng, dùng Capture để đưa nó vào StudyBoard, rồi tự giải thích bằng lời của bạn.',
        primary: 'Chỉ tôi nút Capture',
        dismiss: 'Tôi biết rồi',
    },
    english: {
        title: 'Your PDF is ready. Now capture your first passage.',
        body: 'Read the document in the right panel. When you find an important formula, paragraph, or idea, use Capture to bring it into StudyBoard and explain it in your own words.',
        primary: 'Show me Capture',
        dismiss: 'Got it',
    },
};

export const FirstCaptureNudge: React.FC<FirstCaptureNudgeProps> = ({ language, onShowCapture, onDismiss }) => {
    const t = language === 'vietnamese' ? copy.vietnamese : copy.english;

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[200] w-[340px] max-w-[calc(100vw-2rem)]">
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-indigo-100 dark:border-indigo-900/50 overflow-hidden">
                {/* Header */}
                <div className="flex items-start justify-between gap-3 px-4 pt-4 pb-2">
                    <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-indigo-100 dark:bg-indigo-900/40 flex items-center justify-center flex-shrink-0">
                            <Camera size={14} className="text-indigo-600 dark:text-indigo-400" />
                        </div>
                        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 leading-snug">{t.title}</p>
                    </div>
                    <button
                        onClick={onDismiss}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex-shrink-0 mt-0.5"
                    >
                        <X size={14} />
                    </button>
                </div>

                {/* Body */}
                <p className="px-4 pb-3 text-xs text-gray-500 dark:text-gray-400 leading-relaxed">{t.body}</p>

                {/* Actions */}
                <div className="px-4 pb-4 flex gap-2">
                    <button
                        onClick={onShowCapture}
                        className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-semibold rounded-xl transition-colors"
                    >
                        <Camera size={13} />
                        {t.primary}
                    </button>
                    <button
                        onClick={onDismiss}
                        className="py-2 px-3 text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 font-medium rounded-xl hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors"
                    >
                        {t.dismiss}
                    </button>
                </div>
            </div>
        </div>
    );
};
